import { render, staticRenderFns } from "./LmCheckboxBuilderUi.vue?vue&type=template&id=da26f57a&"
import script from "./LmCheckboxBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmCheckboxBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports